import { render, staticRenderFns } from "./StockMovementTotals.vue?vue&type=template&id=31faad2e&"
import script from "./StockMovementTotals.vue?vue&type=script&lang=js&"
export * from "./StockMovementTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports